export const CARD_DATA = [
  {
    heading: "Comprehensive German Language Training",
    name: "Mr. Keyur Soni",
    details:
      "From A1 to B2, we provide personalized training to ensure fluency and confidence.",
  },

  {
    heading: "Credential Recognition Assistance",
    name: "Mr. Keyur Soni",
    details:
      "Guidance in preparing and submitting documents for qualification equivalency.",
  },

  {
    heading: "Job Placement Support",
    name: "Mr. Keyur Soni",
    details:
      "Connect with reputed hospitals, nursing homes, and healthcare facilities.",
  },

  {
    heading: "Visa Application Guidance",
    name: "Mr. Keyur Soni",
    details:
      "Expert assistance to help you navigate the visa process effortlessly.",
  },

  {
    heading: "Your Gateway to German Education",
    name: "Mr. Keyur Soni",
    // details:'Expert assistance to help you navigate the visa process effortlessly.',
    detailList: [
      {
        listName: "Course & University Matchmaking.",
      },
      {
        listName: "Visa Made Easy",
      },
      {
        listName: "Life In Germany Assistance",
      },
    ],
  },
  {
    heading: "From Aspirations to Admissions",
    name: "Mr. Keyur Soni",
    // details:'Expert assistance to help you navigate the visa process effortlessly.',
    detailList: [
      {
        listName: "Goal-Oriented Planning.",
      },
      {
        listName: "Smooth Onboarding Support.",
      },
      {
        listName: "End-To-End Assistance.",
      },
    ],
  },
];
